export const COMMISSIONS = {
  PERCENT_OF_ORDER: { label: 'Percent of order', unit: '%' },
  KILOMETRAGE:      { label: 'Kilometrage',      unit: '€/KM' },
  BASIC_FARE_COST:  { label: 'Basic fare cost',  unit: '€' },
  MONTHLY_FEE:      { label: 'Monthly fee',      unit: '€' },
} as const;